<template>
  <div>
    <div class="d-flex flex-row-column justify-content-between">
      <span class="page-title mt-2">{{ $tc('general.store_agent', 2) }}</span>
      <span class="d-flex flex-row-column">
        <span class="input-width-160 r-width-100 d-inline-block mr-3">
          <md-field>
            <label for="lmt_id">{{ $t('lmt_specific.filter_by_lmt') }}</label>
            <md-select
              v-on:input="filterResults($event,'lmt_id')"
              name="lmt_id"
              id="lmt_id"
              v-model="lmt_id"
            >
              <md-option value>Show All</md-option>
              <md-option v-for="(item, index) in lmts" :key="index" :value="item.id">{{item.name}}</md-option>
            </md-select>
          </md-field>
        </span>
        <span class="input-width-160 r-width-100 d-inline-block mr-3">
          <md-field>
            <label for="filter">Filter by status</label>
            <md-select
              v-on:input="filterResults($event)"
              name="filter"
              id="filter"
              v-model="status"
            >
              <md-option value>Show All</md-option>
              <md-option value="1">Only Active</md-option>
              <md-option value="0">Only Inactive</md-option>
            </md-select>
          </md-field>
        </span>
        <span class="input-width-160 r-width-100 d-inline-block mr-3">
          <md-field>
            <label for="state_id">Filter by State</label>
            <md-select
                v-on:input="filterResults($event,'state_id')"
                name="state_id"
                id="state_id"
                v-model="state_id"
            >
              <md-option value>Show All</md-option>
              <md-option v-for="(item, index) in states" :key="index" :value="item.id">{{item.name}}</md-option>
            </md-select>
          </md-field>
        </span>
        <span class="input-width-330 r-width-100 d-inline-block">
          <md-field>
            <label>Search</label>
            <md-input v-on:keyup="search" v-model="search_term"></md-input>
            <md-icon>search</md-icon>
          </md-field>
        </span>
      </span>
    </div>
    <hr class="hr-line" />
    <md-table v-if="items.length>0"  v-show="!loading" v-model="items" >
      <md-table-row slot="md-table-row" slot-scope="{ item }">
        <md-table-cell :md-label="$t('general.agent_id')">{{ item.agent_id }}</md-table-cell>
        <md-table-cell :md-label="$t('general.agent_name')">
          <router-link :to="'/bank/agents/'+item.id">{{item.name}}</router-link>
        </md-table-cell>
        <md-table-cell :md-label="$tc('general.lmt', 1)">
          <router-link :to="'/bank/lmt/'+item.lmt_id">{{ item.lmt_name }}</router-link>
        </md-table-cell>
        <md-table-cell md-label="Status">
          <span v-if="item.status==1">Active</span>
          <span v-else>Inactive</span>
        </md-table-cell>
      </md-table-row>
    </md-table>
    <pagination
      v-on:change="paginationChange($event)"
      v-on:change_per_page="changePerPage($event)"
      v-if="items.length>0&&pagination && !loading"
      :meta="pagination.meta"
      :links="pagination.links"
      :per_page="per_page"
    />
    <empty-state v-if="!loading&&items.length==0" />
    <loading v-if="loading" />
  </div>
</template>
<script>
// import pagination methods paginationChange and changePerPage
import Pagination from "../../../mixins/pagination.js";

// mixin for loading data and state
import DataMixin from "../../../mixins/data.js";

export default {
  mixins: [Pagination, DataMixin],

  data() {
    return {
      status: 1,
      lmt_id: "",
      lmts: [],
      state_id: "",
      states: [],
      per_page: 10,
      search_term: "",
      // url for loading data
      api_url: "/bank/lmt-agents",
      page: 1,
      //IMPORTANT loaded data is stored in items
      items: []
    };
  },
  created() {
    this.loadData();

    axios.get("/report/lmts-dropdown").then(({ data }) => {
      this.lmts = data.lmts;
    });

    axios.get("/states").then(({ data }) => {
      this.states = data.states;
    });
  }
};
</script>